<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout justify-center>
          <v-flex xs12 md8 lg6>
            <v-card class="main-card" flat>
              <v-flex>
                <v-responsive :aspect-ratio="16 / 9">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline ps-2 pa-1">{{ $t("staffPage.addStaffTitle") }}</div>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="form" class="pa-4 pt-6">
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.first_name"
                        :rules="[rules.required]"
                        :label="$t('staffPage.firstName')"
                        type="text"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.last_name"
                        :rules="[rules.required]"
                        :label="$t('staffPage.lastName')"
                        type="text"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.username"
                        :rules="[rules.email]"
                        :label="$t('staffPage.email')"
                        type="email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.password"
                        :rules="[rules.password]"
                        :label="$t('staffPage.password')"
                        type="password"
                      ></v-text-field
                    ></v-flex>
                    <v-flex>
                      <v-select
                        outline
                        v-model="model.gender"
                        :label="$t('staffPage.gender')"
                        :items="genderItems"
                        dense
                      ></v-select
                    ></v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.birthday"
                        :rules="[rules.required]"
                        :label="$t('staffPage.dateOfBirth')"
                        type="date"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.phone_number"
                        :rules="[rules.required]"
                        :label="$t('staffPage.phoneNumber')"
                        type="phone"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <choose-image-single
                        v-model="model.profile_image"
                        :label="$t('staffPage.profileImage')"
                      />
                    </v-flex>
                    <v-flex>
                      <choose-role-single
                        v-model="model.role_id"
                        :label="$t('staffPage.role')"
                      />
                    </v-flex>
                    <v-flex class="mt-4">
                      <v-btn
                        :loading="loading"
                        @click="addStaff"
                        color="primary"
                        dark
                        large
                        class="btn"
                        >{{ $t("staffPage.create") }}</v-btn
                      >
                      <v-btn
                        @click="$router.push('/staff')"
                        color="grey"
                        dark
                        large
                        class="btn ms-2"
                        >{{ $t("staffPage.cancel") }}</v-btn
                      >
                    </v-flex>
                  </v-form>
                </v-responsive>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style>
.main-card {
  min-width: 500px;
  max-width: 700px;
  margin: 0 auto;
}
.btn {
  margin-top: 20px;
}
</style>

<script>
import axios from "axios";
import api from "@/constants/api.js";
import ChooseImageSingle from "@/components/monaco/input/ChooseImage.vue";
import ChooseRoleSingle from "@/components/monaco/input/ChooseRoleSingle.vue";

export default {
  title() {
    return this.$t("staffPage.pageTitle");
  },
  components: { ChooseImageSingle, ChooseRoleSingle },
  data: () => ({
    api,
    loading: false,
    error: false,
    model: {
      first_name: "",
      last_name: "",
      username: "",
      password: "",
      gender: "",
      birthday: "",
      phone_number: "",
      profile_image: "",
      role_id: null,
    },
    form: false,
  }),

  computed: {
    // Values stay "Male"/"Female" (API contract); only the displayed text is localized
    genderItems() {
      return [
        { text: this.$t("staffPage.genderMale"), value: "Male" },
        { text: this.$t("staffPage.genderFemale"), value: "Female" },
      ];
    },
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("staffPage.ruleEmail"),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("staffPage.rulePassword"),
        required: (v) => !!v || this.$t("staffPage.ruleRequired"),
      };
    },
  },

  methods: {
    addStaff() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        
        // Convert gender to boolean (true = Male, false = Female)
        // FormData converts boolean to string, so we use 1/0 which Laravel reads as boolean
        const genderValue = this.model.gender === "Male" ? 1 : 0;
        formData.append("gender", genderValue);
        
        formData.append("first_name", this.model.first_name);
        formData.append("last_name", this.model.last_name);
        formData.append("username", this.model.username);
        formData.append("password", this.model.password);
        formData.append("birthday", this.model.birthday);
        formData.append("phone_number", this.model.phone_number);
        
        if (this.model.profile_image) {
          formData.append("profile_image", this.model.profile_image);
        }
        
        if (this.model.role_id) {
          formData.append("role_id", this.model.role_id);
        }

        this.loading = true;

        this.axios
          .post(this.api.ACTIONS.STAFF, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("staffPage.staffAdded"), "green");
            this.$router.push("/staff");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("staffPage.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
    },
  },
};
</script>
